module.exports = __webpack_public_path__ + "img/result_error.630abe2.png";